import { bindable } from "aurelia";

export class SwitchComponent {

  private id = crypto.randomUUID();

  @bindable checked;
  @bindable disabled;
  @bindable label
}